import React, { useState } from 'react';
import {
   Overlay,
   Global,
   Header,
   SlickWrapper,
   ImgWrapper,
   Indicator,
   SlickComponent,
} from './styles';
import { TransformWrapper, TransformComponent } from "@pronestor/react-zoom-pan-pinch";

const ImagesZoom = ({ images, onClose }) => {
   const [currentSlide, setCurrentSlide] = useState(0);
   const [scale, setScale] = useState(1);

   const zoomableDivStyle = { width: '100%' };

   return (
      <Overlay>
         <Global />
         <Header>
            <div onClick={onClose}>
               <img src="/img/closeBtn.svg" alt="닫기 버튼" />
            </div>
         </Header>

         <SlickWrapper>
            <SlickComponent
               initialSlide={0}
               beforeChange={(_, newSlide) => setCurrentSlide(newSlide)}
               infinite
               arrows={false}
               slidesToShow={1}
               slidesToScroll={1}
            >
               {images.map((v, i) => (
                  <TransformWrapper
                     key={i}
                     centerOnInit
                     initialScale={scale}
                     panning={{ disabled: scale <= 1, velocityDisabled: true }}
                     onZoom={ref => setScale(ref.state.scale)}
                  >
                     <TransformComponent
                        wrapperStyle={zoomableDivStyle}
                        contentStyle={zoomableDivStyle}
                     >
                        <ImgWrapper>
                           <img
                              src={`${v}?w=400&h=300`}
                              alt="이미지 확대"
                              style={zoomableDivStyle}
                           />
                        </ImgWrapper>
                     </TransformComponent>
                  </TransformWrapper>
               ))}
            </SlickComponent>
            <Indicator>
               <div>
                  <span>{currentSlide + 1}</span> / {images.length}
               </div>
            </Indicator>
         </SlickWrapper>
      </Overlay>
   );
};

export default ImagesZoom;
